import { all, put, takeEvery, call, select } from "redux-saga/effects";
import { CREW_MEMBERS_ACTIONS, CREW_MEMBERS_TYPES } from "./actions";
import {
  getCrewMember as APIgetCrewMember,
  getCrewMembers as APIgetCrewMembers,
  createCrewMember as APIcreateCrewMember,
  updateCrewMember as APIupdateCrewMember,
  deleteCrewMember as APIdeleteCrewMember
} from "../../services/api/crewMembers";
import { navigateTo } from "../navigation/saga";
import { crewMembersFilters } from "./selectors";
import { ajaxErrorHandler } from "../../libs/utils";

export function* watchCrewMembersActions() {
  yield all([takeEvery(CREW_MEMBERS_TYPES.LOAD_ALL_REQUEST, getCrewMembers)]);
  yield all([takeEvery(CREW_MEMBERS_TYPES.LOAD_REQUEST, getCrewMember)]);
  yield all([takeEvery(CREW_MEMBERS_TYPES.CREATE_REQUEST, createCrewMember)]);
  yield all([takeEvery(CREW_MEMBERS_TYPES.UPDATE_REQUEST, updateCrewMember)]);
  yield all([takeEvery(CREW_MEMBERS_TYPES.DELETE_REQUEST, deleteCrewMember)]);
  yield all([takeEvery(CREW_MEMBERS_TYPES.CREATE_SUCCESS, getCrewMembers)]);
  yield all([takeEvery(CREW_MEMBERS_TYPES.DELETE_SUCCESS, getCrewMembers)]);
  yield all([takeEvery(CREW_MEMBERS_TYPES.UPDATE_FILTERS, getCrewMembers)]);
}

function* getCrewMembers(action) {
  try {
    const filters = yield select(crewMembersFilters);
    const crewMembers = yield call(APIgetCrewMembers, filters);
    yield put(CREW_MEMBERS_ACTIONS.loadAllSuccess(crewMembers));
  } catch (e) {
    yield call(ajaxErrorHandler, e);
    yield put(CREW_MEMBERS_ACTIONS.loadAllFailure(e));
  }
}

function* getCrewMember(action) {
  const { id } = action.payload;
  try {
    const crewMember = yield call(APIgetCrewMember, id);
    yield put(CREW_MEMBERS_ACTIONS.loadSuccess(crewMember));
  } catch (e) {
    yield call(ajaxErrorHandler, e);
    yield put(CREW_MEMBERS_ACTIONS.loadFailure(e));
  }
}

function* createCrewMember(action) {
  const { values, redirect } = action.payload;
  try {
    const crewMember = yield call(APIcreateCrewMember, values);
    yield put(CREW_MEMBERS_ACTIONS.createSuccess(crewMember));
    if (redirect) {
      yield call(navigateTo, redirect);
    }
  } catch (e) {
    yield call(ajaxErrorHandler, e);
    yield put(CREW_MEMBERS_ACTIONS.createFailure(e));
  }
}

function* updateCrewMember(action) {
  const { id, values } = action.payload;
  try {
    const crewMember = yield call(APIupdateCrewMember, id, values);
    yield put(CREW_MEMBERS_ACTIONS.updateSuccess(crewMember));
  } catch (e) {
    yield call(ajaxErrorHandler, e);
    yield put(CREW_MEMBERS_ACTIONS.updateFailure(e));
  }
}

function* deleteCrewMember(action) {
  const { id } = action.payload;
  try {
    const crewMember = yield call(APIdeleteCrewMember, id);
    yield put(CREW_MEMBERS_ACTIONS.deleteSuccess(crewMember));
  } catch (e) {
    yield call(ajaxErrorHandler, e);
    yield put(CREW_MEMBERS_ACTIONS.deleteFailure(e));
  }
}
